module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/@utex/base-api-sdk/~/axios/index.js
// module id = 1637
// module chunks = 118